import { useEffect } from 'preact/hooks';

type Props = {
  badgeId: string;
  icon: string;
  label: string;
  onShare: () => void;
  onDismiss: () => void;
};

export function MilestoneToast({ badgeId: _badgeId, icon, label, onShare, onDismiss }: Props) {
  useEffect(() => {
    const t = setTimeout(onDismiss, 4000);
    return () => clearTimeout(t);
  }, [onDismiss]);

  return (
    <div class="milestone-toast" role="alert" aria-live="assertive">
      <span class="milestone-toast-icon">{icon}</span>
      <div class="milestone-toast-body">
        <span class="milestone-toast-eyebrow">Achievement unlocked</span>
        <span class="milestone-toast-label">{label}</span>
      </div>
      <button type="button" class="milestone-toast-share" onClick={onShare} aria-label="Share achievement">
        Share
      </button>
      <button type="button" class="milestone-toast-close" onClick={onDismiss} aria-label="Dismiss">×</button>
    </div>
  );
}
